import React from "react";
import { logoImg } from "../../assets";
const Logo = ({ name }) => {
  return (
    <h2 className="flex items-center">
      <img
        src={logoImg}
        className="h-[55px] w-[55px] border object-bottom border-gray-400 p-1 rounded-full"
        alt="iman saadat front-end developer"
      />
      <span className="uppercase text-base tracking-wide text-secondaryColor font-medium ml-2">
        {name}
      </span>
    </h2>
  );
};

export default Logo;
